const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Theater extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Theater.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.cultureProductionCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount() * multiplier,
                        });
                        playerState.happyFaceCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount(),
                        });
                    }
            }
        )
        // Culture per theater (worker), e.g. for Charles Chaplin
        this.multiplier = multiplier;
        // Happy faces per theater, e.g. for Michelangelo
        this.happyFaces = 1;
    }
    static GetType = () => TechnologyTypes.Urban.Theater;
}

class Drama extends Theater {
    constructor(){
        super(Drama.GetAge(), Drama.GetName(), 3, 4, 2)
    }

    static GetInstance = () => new Drama();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Urban.Drama;
}

class Opera extends Theater {
    constructor(){
        super(Opera.GetAge(), Opera.GetName(), 7, 8, 3)
    }

    static GetInstance = () => new Opera();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Urban.Opera;
}

class Movies extends Theater {
    constructor(){
        super(Movies.GetAge(), Movies.GetName(), 10, 11, 4)
    }

    static GetInstance = () => new Movies();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Urban.Movies;
}

module.exports = {
    Drama,
    Opera,
    Movies
}